// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__MlK7n","boxTitle":"Qualiphy_boxTitle__1a8CL","box":"Qualiphy_box__cMijC","toggleWrap":"Qualiphy_toggleWrap__-chof"};